export default __webpack_public_path__ + "static/media/facebook.fef8c189.png";